import { IClarity } from '../clarity';
import { Gtag } from '../gtag';

export const consent = (gtag: Gtag | Error, clarity: IClarity | Error) => (consent: boolean) => {
    if (gtag instanceof Error || clarity instanceof Error)
        return;

    if (consent) {
        gtag('consent', 'update', {
            ad_user_data: 'granted',
            ad_personalization: 'granted',
            ad_storage: 'granted',
            analytics_storage: 'granted',
        });
        clarity('consent');
    } else {
        gtag('consent', 'update', {
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            ad_storage: 'denied',
            analytics_storage: 'denied',
        });
        clarity('consent', false);
    }
};
